<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre3"></div>
<div class="mt" id="id_001">
<img alt="frontispiece" class="calibre4" id="id-8711375981964456315" src="OEBPS/Images/3087994011254559640_illus-fpc.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section000.vue?26495195